/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
// NOTE: this component is based off of the signal sauce date time picker

import React from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { ThemeProvider } from "@material-ui/core/styles";
import { debounce } from "underscore";

import DatePickerTheme from "../theme/datePickerTheme";

type DatePickerProps = {
  disabled?: boolean;
  handleChange: (date: Date | null) => void;
  id: string;
  label: string;
  maxDate?: Date;
  maxDateMessage?: string;
  minDate?: Date;
  minDateMessage?: string;
  value: string;
};

const DatePicker: React.FunctionComponent<DatePickerProps> = ({
  disabled,
  handleChange,
  id,
  label,
  maxDate,
  maxDateMessage,
  minDate,
  minDateMessage,
  value,
}: DatePickerProps) => {
  const onChange = debounce((date: MaterialUiPickersDate) => {
    if (date) {
      handleChange(date);
    } else {
      handleChange(null);
    }
  }, 500);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={DatePickerTheme}>
        <KeyboardDatePicker
          autoOk
          disabled={disabled}
          format="MM/dd/yyyy"
          id={id}
          InputLabelProps={{ shrink: true }}
          KeyboardButtonProps={{ "aria-label": "change date" }}
          label={label}
          margin="normal"
          maxDate={maxDate}
          maxDateMessage={maxDateMessage}
          minDate={minDate}
          minDateMessage={minDateMessage}
          onChange={onChange}
          value={value}
          variant="inline"
        />
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

DatePicker.defaultProps = {
  maxDate: new Date("2999-01-01"),
  maxDateMessage: "Date cannont be before maximum allowed date.",
  minDate: new Date("2000-01-01"),
  minDateMessage: "Date cannont be before minimum allowed date.",
};

export default DatePicker;
